import { faFile, faSquareMinus, faSquarePlus } from "@fortawesome/free-regular-svg-icons";
import { faPen, faUsers } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getAccessToken } from "../../../common/authorization/AuthorizeService";
import { MessageContext } from "../../../common/message";
import { ThemeContext } from "../../../common/theme/ThemeContext";
import Tooltip from "../../../common/tooltip/Tooltip";
import { DELETE, GET } from "../../../utils/fetchUtil";
import "./CandidatesTable.scss";
import CustomCreateCandidate from "./customModals/CustomCreateCandidate";
import CustomEditCandidate from "./customModals/CustomEditCandidate";

const CandidatesTable = ({ areInputFieldsDisabled, dispatch, electionState }) => {
  const theme = useContext(ThemeContext);
  const message = useContext(MessageContext);
  const { t } = useTranslation();

  const [candidateModal, setCandidateModal] = useState(false);
  const [candidateModalEdit, setCandidateModalEdit] = useState(false);
  const [candidateEdit, setCandidateEdit] = useState();
  const [candidates, setCandidates] = useState();
  const [fetchCandidatesTrigger, setFetchCandidatesTrigger] = useState(0);

  const handlePlusClick = () => {
    setCandidateModal(true);
  };

  const handleEditClick = (rowIndex) => {
    setCandidateEdit(candidates[rowIndex]);
    setCandidateModalEdit(true);
  };

  const handleDeleteClick = (rowIndex) => {
    message.toggle({
      title: "Napomena",
      content: "Jeste li sigurni da želite izbrisati kandidata?",
      yesLabel: t("modalMessage.yesLabel"),
      onYes: () => {
        let candidateForDeletion = candidates[rowIndex];
        DELETE(
          "/candidate?candidateId=" + candidateForDeletion.id,
          (response) => {
            // Trenutno se ponovo zove API pa svejedno se ukloni taj kandidat
            // setCandidates(...candidates, candidates.splice(rowIndex, 1));
            setFetchCandidatesTrigger((prevState) => prevState + 10);
          },
          (error) => {
            message.toggle({
              title: t("requests.reviewDocuments.action.save.error"),
              content: error,
              hideNo: true,
              yesLabel: t("modalMessage.okLabel"),
              onYes: () => {
                message.toggle({});
              },
            });
          }
        );
        message.toggle({});
      },
      onNo: () => message.toggle({}),
    });
  };

  useEffect(() => {
    if (electionState.id) {
      GET(
        "/candidates?electionId=" + electionState.id,
        (response) => {
          setCandidates(response);
          dispatch({ type: "update", payload: { candidates: response } });
        },
        (error) => {
          message.toggle({
            title: t("requests.reviewDocuments.action.save.error"),
            content: error,
            hideNo: true,
            yesLabel: t("modalMessage.okLabel"),
            onYes: () => {
              message.toggle({});
            },
          });
        }
      );
    }
  }, [electionState.id, fetchCandidatesTrigger]);

  const getFileFromServer = async (fileUrl) => {
    message.toggle({
      show: true,
      title: "",
      content: t("requests.wait.label"),
      hideNo: true,
      hideYes: true,
      isWait: true,
      hideX: false,
    });
    fetch(`${process.env.REACT_APP_GATEWAY_URL}${fileUrl}`, {
      method: "GET",
      headers: {
        "Request-Origin": "pisarnica",
        Authorization: "Bearer " + (await getAccessToken()),
      },
      mode: "cors",
      credentials: "include",
    })
      .then((response) => response.blob())
      .then((file) => window.open(URL.createObjectURL(file)) && message.toggle({ show: false }));
  };

  return (
    <>
      <CustomCreateCandidate
        setCandidateModal={setCandidateModal}
        active={candidateModal}
        electionState={electionState}
        dispatch={dispatch}
        setFetchCandidatesTrigger={setFetchCandidatesTrigger}
      />
      <CustomEditCandidate
        setCandidateModalEdit={setCandidateModalEdit}
        active={candidateModalEdit}
        candidateEdit={candidateEdit}
        electionState={electionState}
        dispatch={dispatch}
        setFetchCandidatesTrigger={setFetchCandidatesTrigger}
      />
      <div className="columns is-mobile mt-4 is-centered ">
        <div className="column is-10 is-centered">
          {/* Header - icon and title */}
          <div className="columns">
            <div className="column is-1 is-flex is-align-items-center is-justify-content-center">
              <div className="is-flex is-align-items-center is-justify-content-center">
                <FontAwesomeIcon
                  icon={faUsers}
                  size="2x"
                  className={`has-text-${theme.iconColor}`}
                />
              </div>
            </div>
            <div className="column is-flex is-align-items-center">
              <h3 className="m-0 is-size-3">Kandidati ({candidates && candidates.length})</h3>
            </div>
          </div>
          {/* Tablica s podacima */}
          <div className="columns">
            <div className="column is-1 vote-table-left-line">
              <div className="is-flex is-align-items-center is-justify-content-center">
                {/* Linija ispod ikone */}
                {/* <div
            style={{ width: "49%", height: "100px", borderRight: "1px solid black" }}
          >
          </div>
          <div style={{ width: "50%", height: "100px" }}></div> */}
              </div>
            </div>

            <form style={{ width: "100%", height: "100%" }}>
              <div className="vote-table-info column is-flex is-align-items-center">
                <table className="table is-bordered is-hoverable">
                  <thead>
                    <tr>
                      <th>Evidencijski broj</th>
                      <th>Ime i prezime</th>
                      <th>Ustanova zaposlenja</th>
                      <th
                        style={{ border: 0 }}
                        className="is-flex is-justify-content-space-between"
                      >
                        Dokumentacija
                        {areInputFieldsDisabled ? null : (
                          <div
                            className="add-candidate-plus-icon is-flex is-align-items-center is-justify-content-center ml-4"
                            onClick={handlePlusClick}
                          >
                            <Tooltip
                              delay={"0"}
                              content={"Dodaj kandidata"}
                              children={
                                <FontAwesomeIcon
                                  icon={faSquarePlus}
                                  size="2x"
                                  className={`has-text-${theme.iconColor}`}
                                />
                              }
                            ></Tooltip>
                          </div>
                        )}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {candidates && candidates?.length === 0 ? (
                      <tr style={{ height: "44px" }}>
                        <td className="remove-right-border"></td>
                        <td className="remove-left-border remove-right-border"></td>
                        <td className="remove-left-border remove-right-border"></td>
                        <td className="remove-left-border"></td>
                      </tr>
                    ) : (
                      candidates &&
                      candidates.map((candidate, index) => {
                        return (
                          <tr key={index}>
                            <td className="remove-right-border is-vcentered">
                              {candidate.evidencijskiBrojEhkms}
                            </td>
                            <td className="remove-left-border remove-right-border is-vcentered">
                              {candidate.nameAndSurname}
                            </td>
                            <td className="remove-left-border remove-right-border is-vcentered">
                              {candidate.institution}
                            </td>
                            <td className="remove-left-border is-vcentered">
                              {candidate.documentation?.map((file, index) => {
                                const fileName = file.fileUrl.split("_user_")[1];
                                return (
                                  <Tooltip
                                    delay={"0"}
                                    key={index}
                                    content={fileName}
                                    children={
                                      <div
                                        onClick={() => {
                                          getFileFromServer(file.fileUrl);
                                        }}
                                        className="file-icon-div"
                                        style={{ marginTop: "2px" }}
                                      >
                                        <FontAwesomeIcon
                                          key={index}
                                          icon={faFile}
                                          className="is-size-4 ml-1"
                                        />
                                      </div>
                                    }
                                  ></Tooltip>
                                );
                              })}

                              {areInputFieldsDisabled ? null : (
                                <div className="pen-minus-icons-div">
                                  <Tooltip
                                    delay={"0"}
                                    content={"Uredi kandidata"}
                                    children={
                                      <FontAwesomeIcon
                                        icon={faPen}
                                        style={{ float: "right" }}
                                        className="is-size-5 has-pointer-cursor"
                                        onClick={() => handleEditClick(index)}
                                      />
                                    }
                                  ></Tooltip>
                                  <div className="ml-3 mr-3" style={{ display: "inline" }}></div>
                                  <Tooltip
                                    delay={"0"}
                                    content={"Obriši kandidata"}
                                    children={
                                      <FontAwesomeIcon
                                        icon={faSquareMinus}
                                        style={{ color: "RGB(217, 83, 79)", float: "right" }}
                                        className="is-size-4 has-pointer-cursor"
                                        onClick={() => handleDeleteClick(index)}
                                      />
                                    }
                                  ></Tooltip>
                                </div>
                              )}
                            </td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </table>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default CandidatesTable;
